angular.module("ainapp")
    .controller("counterController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$http", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $http, $window) {

            $scope.PageName = "Counters";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }



            $scope.PrintSetting = {};
            MainService.PrintSettingsbyType("Counter Closing").then(function (response) {
                $scope.PrintSetting = response.data;
            });

            $scope.CProfile = {};
            MainService.GetCompanyProfile().then(function (res) {
                if (res.data != null) {
                    $scope.CProfile = res.data;
                }
            })


            $scope.Init = function () {

                $scope.TokenInfo = AuthenticationService.getTokenInfo();
                $scope.Viewval = 0;

                $scope.Load = false;
                $scope.Screen = 0;
                $scope.Subtotal = 0;
                $scope.TotalVat = 0;
                $scope.TotalOrders = 0;
                $scope.Totaldiscount = 0;
                $scope.Total = 0;
                $scope.Taxable = 0;
                $scope.Sales = [];
                $scope.Counter = {
                    Date: new Date(),
                };

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.LastCounter($scope.TokenInfo.Id).then(function (response) {
                    if (response.data != null) {
                        $scope.Counter = response.data;
                        $scope.Counter.DateOpen = new Date($scope.Counter.DateOpen);
                        $scope.Counter.DateClosed = new Date();

                        $.LoadingOverlay("show", {
                            image: "images/load.gif",
                        });
                        MainService.getCounterSalesIForClose($scope.Counter.Id).then(function (response) {
                            if (response.data != null) {
                                $scope.Sales = response.data;

                                angular.forEach($scope.Sales, function (e) {
                                    $scope.Subtotal = $scope.Subtotal + e.SubTotal;
                                    $scope.TotalVat = $scope.TotalVat + e.TotalVAT;
                                    $scope.Totaldiscount = $scope.Totaldiscount + e.TotalDiscount;
                                    $scope.Total = $scope.Total + e.GrandTotal;
                                    $scope.Taxable = $scope.Taxable + e.Taxable;
                                })

                                $scope.TotalOrders = $scope.Sales.length;

                            } else {
                                toastr.warning("No Sales Done For This Counter");
                            }
                            $.LoadingOverlay("hide");
                        }, function (err) {
                            $.LoadingOverlay("hide");
                            toastr.error("Network Error");
                        });

                    } else {
                        $scope.Screen = 1;
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                });

            }
            $scope.Init();


            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        o.data.UserId = $scope.TokenInfo.Id;
                        MainService.CountersByUserId(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            OpenDate: {
                                type: "date",
                                editable: false,
                            },
                            ClosingDate: {
                                type: "date",
                                editable: false,
                            },
                            IsClose: {
                                type: "boolean",
                                editable: false,
                            },
                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20
            });

            $scope.KendoGridOptions = {


                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 400,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: false,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },


                columns: [
                    {
                        field: "OpenDate",
                        title: "Open",
                        template: "#= kendo.toString(kendo.parseDate(OpenDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        },
                    {
                        field: "ClosingDate",
                        title: "Close",
                        template: "#= kendo.toString(kendo.parseDate(ClosingDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        },
                    {
                        field: "IsClose",
                        title: "Closed?",
                        template: "<p ng-if='dataItem.IsClose == true'>Yes</p><p ng-if='dataItem.IsClose == false'>No</p>"
                        },

//                    {
//                        title: "Options",
//                        headerTemplate: " Options ",
//                        template: "<button class='btn btn-danger btn-sm'  ng-click='DeleteAccType(dataItem)'>Delete  </button> ",
//                        width: '120px'
//                        },
                    ],
            };


            $scope.SelectedDataForDelete = {};
            $scope.DeleteAccType = function (data) {
                $scope.SelectedDataForDelete = data;
                $("#deleteModal").modal("show");
            }

            $scope.deleteWithConfirm = function () {
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteCounter($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data == 1) {
                        $('#myModal2').modal('hide');
                        toastr.success("Deleted");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    } else {
                        toastr.success("Cannot Delete Sales Done !");
                    }
                    $.LoadingOverlay("hide");
                    $scope.Load = false;
                }, function (err) {
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                });
            }

            $scope.CounterOpen = function () {
                if ($scope.IsValidFinYear == false) {
                    toastr.info("Operation Not Possible, Current Financial Year Closed.");
                } else {

                    $scope.Load = true;

                    var data = {};

                    data.OpenDate = new Date($scope.Counter.Date);
                    data.OpenMonth = data.OpenDate.getMonth() + 1;
                    data.OpenDay = data.OpenDate.getDate();
                    data.OpenYear = data.OpenDate.getFullYear();
                    data.OpenHour = data.OpenDate.getHours();
                    data.OpenMin = data.OpenDate.getMinutes();

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.StartCounter(data).then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            //                            $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                            $scope.Init();
                        } else {
                            toastr.error("Error");
                        }
                        $scope.Load = false;
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $scope.Load = false;
                        $.LoadingOverlay("hide");
                        toastr.error("Network Error");
                    });
                }

            }

            $scope.CloseCounter = function () {

                if ($scope.IsValidFinYear == false) {
                    toastr.info("Operation Not Possible, Current Financial Year Closed.");
                } else {

                    $scope.Load = true;
                    $scope.Counterdata = {};
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.GetCounterTotals($scope.Counter.Id).then(function (response) {
                        $scope.Counterdata = response.data;
                        $('#closeModel').modal('show');
                        $scope.Load = false;
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.Load = false;
                        $.LoadingOverlay("hide");
                    });
                }
            }

            $scope.CloseWithConfirm = function () {
                $scope.Load = true;

                var data = {};

                data.ClosingDate = new Date($scope.Counter.DateClosed);
                data.CloseMonth = data.ClosingDate.getMonth() + 1;
                data.CloseDay = data.ClosingDate.getDate();
                data.CloseYear = data.ClosingDate.getFullYear();
                data.CloseHour = data.ClosingDate.getHours();
                data.CloseMin = data.ClosingDate.getMinutes();
                data.Id = $scope.Counter.Id;

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.CloseCounter(data).then(function (response) {
                    if (response.data) {
                        toastr.success("Success");
                        $('#closeModel').modal('hide');
                        //                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.Init();
                    } else {
                        toastr.error("Error");
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                });
            }

            $scope.PrintBill = function (temp) {

                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
 
                MainService.PrintCounterClosingReport($scope.Counter.Id).then(function (response) {
                    if (response.data != null) {
                        if(response.data != "No Sales Found !"){
                            $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                        }else{
                              toastr.error(response.data);
                        }
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                })
            }

            $scope.PrintBill3 = function () {

                var qzinfo = qz.websocket.isActive();

                var date = new Date();


                $scope.Counter.OpenDate = new Date($scope.Counter.OpenDate);

                var opendate = $scope.Counter.OpenDate.getDate() + "/" +
                    ($scope.Counter.OpenDate.getMonth() + 1) + "/" +
                    $scope.Counter.OpenDate.getFullYear();

                var openTime = $scope.Counter.OpenDate.getHours() + " : " +
                    $scope.Counter.OpenDate.getMinutes();

                var closedate = $scope.Counter.DateClosed.getDate() + "/" +
                    ($scope.Counter.DateClosed.getMonth() + 1) + "/" +
                    $scope.Counter.DateClosed.getFullYear();

                var closeTime = $scope.Counter.DateClosed.getHours() + " : " +
                    $scope.Counter.DateClosed.getMinutes();


                var billArray = [];
                angular.forEach($scope.Sales, function (e) {
                    //                    var sst = e.Description + "(" + e.Quantity + "*" + e.Price + ")";
                    //                    var arr = 15 - sst.length;
                    //                    var arr2 = arr + 12;
                    //                    var ss = "                               ";
                    //                    itemstring = itemstring + e.BillNo + " " + ss + e.GrandTotal + '\x0A';


                    var temp = {
                        "Date": e.Date.toString(),
                        "BillNo": e.BillNo,
                        "SubTotal": e.SubTotal,
                        "Discount": e.TotalDiscount,
                        "Taxable": e.Taxable,
                        "TotalVAT": e.TotalVAT,
                        "GrandTotal": e.GrandTotal,
                    };
                    billArray.push(temp);
                })

                $scope.SalesPrint = {
                    Date: date.toString(),
                    PayType: "Credit",
                    BillNo: "CSN60",
                    SubTotal: $scope.Subtotal,
                    Taxable: $scope.Taxable,
                    TotalVAT: $scope.TotalVat,
                    TotalDiscount: $scope.Totaldiscount,
                    GrandTotal: $scope.Total,
                    RecievedCash: 0,
                    BalanceCash: 0,
                    SummaryDetails: billArray,
                }

                $scope.SalesPrint.Settings = {
                    PrinterName: $scope.CProfile.PrinterName,
                    PrinterType: 'Default',
                    ItemLength: 40,
                    PrintLogo: true,
                    ThankYouNote: '',
                    EIDRMK: '',
                    PrintType: 'Cash',
                    Logo: $scope.basePath + $scope.CProfile.Logo,
                    TaxType: "Counter Sales Summary",
                    CompanyName: $scope.CProfile.Name,
                    CompanyMobile: $scope.CProfile.MobileNo,
                    CompanyAddress: $scope.CProfile.Address,
                    CompanyEmail: $scope.CProfile.Email,
                    CompanyTRNNO: $scope.CProfile.TRNNo,
                    CompanyWebsite: $scope.CProfile.Website,
                    Staff: "",
                    LogoPath: "D:\\Logo.jpeg",
                    Format: 7,
                    Table: $scope.Counter.Id,
                    DateStart: opendate,
                    DateEnd: closedate,
                    TimeStart: openTime,
                    TimeEnd: closeTime,
                    Opening: "7",
                    Closing: "6",
                    TotalOrders: $scope.Sales.length,

                };

                console.log($scope.SalesPrint);

                $http.post('http://localhost:8090/Party/Print/', $scope.SalesPrint)
                    .then(function (response) {
                        console.log(response.data);
                        $scope.Init();
                    })
                    .catch(function (error) {
                        //                                console.error('Error:', error);
                        //                                $scope.Init();
                        toastr.error("Print Error");
                    });



            }


            $scope.PrintBill2 = function () {

                var qzinfo = qz.websocket.isActive();


                var opendate = $scope.Counter.DateOpen.getDate() + "/" +
                    ($scope.Counter.DateOpen.getMonth() + 1) + "/" +
                    $scope.Counter.DateOpen.getFullYear() + " : " +
                    $scope.Counter.DateOpen.getHours() + " : " +
                    $scope.Counter.DateOpen.getMinutes();

                var closedate = $scope.Counter.DateClosed.getDate() + "/" +
                    ($scope.Counter.DateClosed.getMonth() + 1) + "/" +
                    $scope.Counter.DateClosed.getFullYear() + " : " +
                    $scope.Counter.DateClosed.getHours() + " : " +
                    $scope.Counter.DateClosed.getMinutes();


                var itemstring = "";
                angular.forEach($scope.Sales, function (e) {
                    var sst = e.Description + "(" + e.Quantity + "*" + e.Price + ")";
                    var arr = 15 - sst.length;
                    var arr2 = arr + 12;
                    var ss = "                               ";
                    itemstring = itemstring + e.BillNo + " " + ss + e.GrandTotal + '\x0A';
                })


                var config = qz.configs.create($scope.CProfile.PrinterName, {
                    size: {
                        width: 3.14,
                    },
                    copies: 1,
                    colorType: 'grayscale',
                });

                var data = [
                    '\x1B' + '\x61' + '\x31', // center align
                    {
                        type: 'raw',
                        format: 'image',
                        data: 'images/Print/' + $scope.CProfile.Code + '.jpg',
                        options: {
                            language: "ESCPOS",
                            dotDensity: 'double'
                        }
                    },
                    '\x1B' + '\x40', // init
                    '\x1B' + '\x61' + '\x31', // center align
                    $scope.CProfile.Address + '\x0A',
                    '\x1B' + '\x61' + '\x31', // center align
                    '\x1B' + '\x61' + '\x31', // center align
                    $scope.CProfile.TinNumber + '\x0A',
                    '\x1B' + '\x61' + '\x31', // center align
                    'Counter Closing' + '\x0A',
                    '\x1B' + '\x61' + '\x31', // center align
                    '-----------------' + '\x0A',
                    '\x1B' + '\x45' + '\x0D', // bold on
                    '\x1B' + '\x61' + '\x30', // left align
                    'Date ' + +' \x0A',
                    'Employee : ' + $scope.TokenInfo.UserName + ' \x0A',
                    'Open Date : ' + opendate + ' \x0A',
                    'Close Date : ' + closedate + ' \x0A',
                    '\x1B' + '\x45' + '\x0A', // bold off
                    '\x1B' + '\x61' + '\x30', // left align
                    '\x1B' + '\x61' + '\x31', // center align
                    '-----------------' + '\x0A',
                    '\x0A', // line break
                    '\x1B' + '\x61' + '\x30', // left align
                    itemstring, //print special char symbol after numeric
                    '\x0A',
                    '------------------------------------------' + '\x0A',
                    '\x1B' + '\x61' + '\x31', // center align
                    'Total Orders : ' + $scope.TotalOrders + '\x0A',
                    'Sub Total : ' + $scope.Subtotal + '\x0A',
                    'Total Discount : ' + $scope.Totaldiscount + '\x0A',
                    'Total Vat : ' + $scope.TotalVat + '\x0A',
                    'Total : ' + $scope.Total + '\x0A',
                    '\x0A',
                    '------------------------------------------' + '\x0A',
                    '\x1B' + '\x61' + '\x31', // center align
                    '\x1B' + '\x4D' + '\x31', // small text
                    '\x1B' + '\x61' + '\x31', // center align
                    'Thank You Visit Again' + '\x0A',
                    '\x1B' + '\x4D' + '\x30', // normal text
                    '\x1B' + '\x61' + '\x31', // center align
                    '------------------------------------------',
                    '\x1B' + '\x61' + '\x30', // left align
                    '\x0A' + '\x0A' + '\x0A' + '\x0A' + '\x0A' + '\x0A' + '\x0A',
                    '\x1B' + '\x69', // cut paper (old syntax)
                   // '\x10' + '\x14' + '\x01' + '\x00' + '\x05', // Generate Pulse to kick-out cash drawer**
                    ];


                if (qzinfo == true) {
                    qz.print(config, data).then(function () {
                        console.log("Sent data to printer");
                    }, function (err) {
                        console.log(err);
                    });

                } else {

                    qz.websocket.connect().then(function (res) {
                        console.log("Connected!");
                        qz.print(config, data).then(function () {
                            console.log("Sent data to printer");
                        }, function (err) {
                            console.log(err);
                        });
                    });

                }



            }




        }])
